import { render, staticRenderFns } from "./BaseTooltipIconHtml.vue?vue&type=template&id=89141c60"
import script from "./BaseTooltipIconHtml.vue?vue&type=script&lang=js"
export * from "./BaseTooltipIconHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports